import { ReasonForReturn } from 'services/api/api-client.ts';
import { Option } from 'pages/authorized/create-repair-request/modal-components/AddDeviceModal.tsx';

type TranslateFn = (key: string) => string;

export const reasonConfigs: {
  value: ReasonForReturn;
  translationKey: string;
}[] = [
  {
    value: ReasonForReturn.Maintenance,
    translationKey: 'modal_reason_maintenance',
  },
  {
    value: ReasonForReturn.Repair,
    translationKey: 'modal_reason_repair',
  },
  {
    value: ReasonForReturn.Warranty,
    translationKey: 'modal_reason_warranty_with_receipt',
  },
  {
    value: ReasonForReturn.ReturnForCredit,
    translationKey: 'modal_reason_credit_with_receipt',
  },
  // {
  //   value: ReasonForReturn.ReturnOfExchangeArticle,
  //   translationKey: 'modal_reason_exchange',
  // },
  {
    value: ReasonForReturn.HygienicReprocessingOrdered,
    translationKey: 'modal_reason_hygienic_reprocessing_ordered',
  },
  // {
  //   value: ReasonForReturn.CustomerRequestsCompletion,
  //   translationKey: 'modal_reason_customer_requests_completion',
  // },
  // {
  //   value: ReasonForReturn.CaseIsIncident,
  //   translationKey: 'modal_reason_case_is_incident',
  // },
  // {
  //   value: ReasonForReturn.CustomerWantsCostEstimate,
  //   translationKey: 'modal_reason_customer_wants_cost_estimate',
  // },
];

export const getRepairReasonOptions = (
  translate: TranslateFn,
  availableServices?: ReasonForReturn[] | null,
): Option[] =>
  reasonConfigs
    .filter(
      (item) =>
        availableServices === undefined ||
        availableServices?.includes(item.value) === true,
    )
    .map((item) => ({
      key: item.value,
      text: translate(item.translationKey),
    }));

export const getSelectedReasonOptions = (
  reasonsForReturn: ReasonForReturn[],
  translate: TranslateFn,
): Option[] => {
  return reasonConfigs
    .filter((r1) => reasonsForReturn.find((r2) => r2 === r1.value))
    .map((filteredReason) => ({
      key: filteredReason.value,
      text: translate(filteredReason.translationKey),
    }));
};
